import { createFileRoute } from "@tanstack/react-router";
import ThankYouEligibility from "@/pages/ThankYouEligibility";
export const Route = createFileRoute("/thank-you-eligibility")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "Thank You — We Have Your Information | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Thank you for submitting your eligibility check. A member of our clinical team will call you within one business day in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Thank You — We Have Your Information | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Thank you for submitting your eligibility check. A member of our clinical team will call you within one business day in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/thank-you-eligibility",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/thank-you-eligibility",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ThankYouEligibility />;
}
